export var WorkflowKind;
(function (WorkflowKind) {
    WorkflowKind[WorkflowKind["SingleItem"] = 0] = "SingleItem";
    WorkflowKind[WorkflowKind["Reduce"] = 1] = "Reduce";
    WorkflowKind[WorkflowKind["Grid"] = 2] = "Grid";
    WorkflowKind[WorkflowKind["DynamicText"] = 3] = "DynamicText";
    WorkflowKind[WorkflowKind["Join"] = 4] = "Join";
    WorkflowKind[WorkflowKind["Generic"] = 5] = "Generic";
})(WorkflowKind || (WorkflowKind = {}));
export var WorkflowVisibility;
(function (WorkflowVisibility) {
    /**
     * Output items (annotations/signals) flow across runtimes, e.g. client annotations are sent to the server
     * runtime and the opposite too.
     */
    WorkflowVisibility[WorkflowVisibility["Default"] = 0] = "Default";
    /**
     * Output items do not cross the current runtime boundary, e.g. client annotations stay on the client runtime,
     * they are not sent to the server.
     */
    WorkflowVisibility[WorkflowVisibility["LocalOnly"] = 1] = "LocalOnly";
    /**
     * Deactivate any workflows on the downstream runtime that share the output types, making the workflow on the
     * upstream runtime exclusive.
     */
    WorkflowVisibility[WorkflowVisibility["Exclusive"] = 2] = "Exclusive";
})(WorkflowVisibility || (WorkflowVisibility = {}));
export var ActivationTier;
(function (ActivationTier) {
    ActivationTier[ActivationTier["PreActivate"] = 0] = "PreActivate";
    ActivationTier[ActivationTier["Default"] = 1] = "Default";
    ActivationTier[ActivationTier["DelayActivate"] = 1] = "DelayActivate";
    ActivationTier[ActivationTier["NeverActivate"] = 2] = "NeverActivate";
})(ActivationTier || (ActivationTier = {}));
/**
 * Cardinality of requested context types.
 */
export var RequestedContextCardinality;
(function (RequestedContextCardinality) {
    RequestedContextCardinality[RequestedContextCardinality["Required"] = -3] = "Required";
    RequestedContextCardinality[RequestedContextCardinality["Optional"] = -1] = "Optional"; //ItemCardinality.Any
})(RequestedContextCardinality || (RequestedContextCardinality = {}));
/**
 * Defines whether context consumer waits for context producer to provide a context or not
 */
export var ProducerWaitPolicy;
(function (ProducerWaitPolicy) {
    ProducerWaitPolicy[ProducerWaitPolicy["Never"] = 0] = "Never";
    ProducerWaitPolicy[ProducerWaitPolicy["Always"] = 1] = "Always"; //Consumer waits for context if context producer is running (applies both to optional and required contexts)
})(ProducerWaitPolicy || (ProducerWaitPolicy = {}));
export var InputStage;
(function (InputStage) {
    InputStage[InputStage["PreSeed"] = 1] = "PreSeed";
    InputStage[InputStage["OnSeed"] = 2] = "OnSeed";
    InputStage[InputStage["PostSeed"] = 4] = "PostSeed";
    InputStage[InputStage["All"] = 5] = "All"; // Trigger on any content as soon as it arrives (default). Preseed | Postseed
})(InputStage || (InputStage = {}));
export var TriggerCondition;
(function (TriggerCondition) {
    TriggerCondition[TriggerCondition["UpstreamWorkflowsReady"] = 0] = "UpstreamWorkflowsReady";
    /**
     * In addition to default workflow triggering also trigger workflows when metadata is updated.
     * By default workflows are not triggered on metadata updates.
     */
    TriggerCondition[TriggerCondition["AnnotationMetadataUpdated"] = 1] = "AnnotationMetadataUpdated";
    /**
     * Trigger workflow on every delta update.
     * By default workflow will not be triggered on every delta update operation.
     * Workflow should have this trigger condition set if:
     * Workflow should execute on every character change,
     * or if it uses Delta prefilter,
     * or if it is a JoinWorkflow with a low max delay,
     * or if it uses WorkflowContext.delta or WorkflowModelItem.delta in the lambda function, but it isn't incremental workflow.
     */
    TriggerCondition[TriggerCondition["DeltaUpdate"] = 2] = "DeltaUpdate";
    /**
     * Trigger workflow on either signals or input changes. No-op if workflow is not configured to have trigger signals.
     */
    TriggerCondition[TriggerCondition["NonExclusiveTriggerSignals"] = 3] = "NonExclusiveTriggerSignals";
})(TriggerCondition || (TriggerCondition = {}));
export var UnitType;
(function (UnitType) {
    UnitType[UnitType["Character"] = 1] = "Character";
    UnitType[UnitType["Paragraph"] = 2] = "Paragraph";
})(UnitType || (UnitType = {}));
/**
 * Enumeration of prefilter types.
 */
export var PrefilterType;
(function (PrefilterType) {
    /** Item input predicate lambda prefilter type. */
    PrefilterType["Input"] = "Input";
    /** Item input delta predicate lambda prefilter type. */
    PrefilterType["Delta"] = "Delta";
    /** Supported UI languages for a workflow prefilter type. */
    PrefilterType["UILanguage"] = "UILanguage";
    /** Workflow max input count. */
    PrefilterType["MaxInputCount"] = "MaxInputCount";
})(PrefilterType || (PrefilterType = {}));
/**
* Enumeration of prefilter action types.
*/
export var PrefilterActionType;
(function (PrefilterActionType) {
    /** Set predefined annotation action type. */
    PrefilterActionType["SetPredefinedAnnotation"] = "SetPredefinedAnnotation";
    /** Clear annotations action type. */
    PrefilterActionType["ClearAnnotations"] = "ClearAnnotations";
})(PrefilterActionType || (PrefilterActionType = {}));
//# sourceMappingURL=workflow-definition-base.js.map